<template>
  <div class="row">
    <div class="col-lg-12 col-md-12">
      <card class="shadow-lg">
        <div class="row content-add-btn">
          <button class="btn btn-secondary" @click="$router.go(-1)">
            <em class="fa fa-chevron-left"></em>
            {{ $t('common_words.exit') }}
          </button>
        </div>
        <hr />
        <form-wizard-layout
          ref="formWizard"
          @showHideLoading="showHideLoading"
          @on-validated="onStepValidated"
          @on-complete="storeUpdate"
          :tabsContent="tabsContent"
          v-if="this.isCreate() || this.isUpdate()"
        >
          <template slot="dataConfirm">
            <step-confirm :infoData="model" ref="stepConfirm" />
            <div
              v-if="!model.isCreate"
              class="d-flex justify-content-center mt-3"
            >
              <el-button
                v-if="this.isDelete()"
                class="d-flex justify-content-center"
                @click="deleteCapture()"
                type="danger"
                ><strong>Eliminar Captura</strong></el-button
              >
            </div>
          </template>
        </form-wizard-layout>
        <div v-else>
          <br />
          <h5 class="text-muted text-center">
            {{ $t('common_words.no_permissions_operations') }}
          </h5>
        </div>
      </card>
    </div>
  </div>
</template>
<script>
import i18n from 'src/i18n';
import SweetAlert from 'src/class/Alerts';
import { Axios } from 'src/class/Axios.js';
import MixinMenu from 'src/util/mixinMenu';
import MixinAlert from 'src/mixins/mixin-alert';
import MixinLoading from 'src/mixins/mixin-loading';
import MixinPermissions from 'src/util/mixinPermissions';
import FormWizard from 'src/components/Layouts/FormWizard.vue';
import FirstStep from 'src/views/Pages/Dashboard/Sigatoka/SigatokaCapture/steps/FirstStep.vue';
import ThirdStep from 'src/views/Pages/Dashboard/Sigatoka/SigatokaCapture/steps/ThirdStep.vue';
import ForthStep from 'src/views/Pages/Dashboard/Sigatoka/SigatokaCapture/steps/ForthStep.vue';
import FifthStep from 'src/views/Pages/Dashboard/Sigatoka/SigatokaCapture/steps/FifthStep.vue';
import SecondStep from 'src/views/Pages/Dashboard/Sigatoka/SigatokaCapture/steps/SecondStep.vue';
import StepConfirm from 'src/views/Pages/Dashboard/Sigatoka/SigatokaCapture/steps/StepConfirm.vue';

export default {
  components: {
    [FormWizard.name]: FormWizard,
    FirstStep,
    SecondStep,
    ThirdStep,
    ForthStep,
    StepConfirm,
  },
  data() {
    return {
      model: {
        id: null,
        age: [],
        date: null,
        lot_id: null,
        farm_id: null,
        isCreate: true,
        hasYoungPlants: false,
        sigatoka_config_id: null,
        first_step: {},
        second_step: {},
        third_step: {},
        forth_step: {},
        fifth_step: {},
      },
    };
  },
  mixins: [MixinPermissions, MixinMenu, MixinLoading, MixinAlert],
  computed: {
    tabsContent() {
      if (!this.model.age) return [];
      const getTitle = (age) => {
        if (age === 0) return i18n.t('sigatoka.expecting');
        if (age === 1) return i18n.t('sigatoka.newly_given_birth');
        return `${age} ${i18n.t('common_words.weeks')}`;
      };
      const steps = [
        { ref: 'firstStep', component: FirstStep },
        { ref: 'secondStep', component: SecondStep },
        { ref: 'thirdStep', component: ThirdStep },
        { ref: 'forthStep', component: ForthStep },
      ];
      const tabs = this.model.age
        .map((age, index) => {
          const step = steps[index];
          if (!step) return null;

          return {
            title: getTitle(age),
            reference: step.ref,
            component: step.component,
          };
        })
        .filter(Boolean);
      if (this.model.hasYoungPlants)
        tabs.push({
          title: i18n.t('sigatoka.young_plants'),
          reference: 'fifthStep',
          component: FifthStep,
        });

      return tabs;
    },
    getModuleRoute() {
      return 'sigatoka/capture';
    },
  },
  methods: {
    validateStep(ref) {
      return this.$refs[ref].validate();
    },
    hasValidData(step) {
      if (!step || !step.plant) return false;
      if (step.key == 'fifth_step') {
        return step.plant.some((_, index) => {
          const fl = step.functional_leaf[index];
          const ref = step.ref[index];

          return (
            (fl !== null && fl !== undefined && fl !== '') ||
            (ref !== null && ref !== undefined && ref !== '')
          );
        });
      } else
        return step.plant.some((_, index) => {
          const fl = step.functional_leaf[index];
          const yls = step.yls[index];

          return (
            (fl !== null && fl !== undefined && fl !== '') ||
            (yls !== null && yls !== undefined && yls !== '')
          );
        });
    },
    onStepValidated(dataModel) {
      this.model[dataModel.key] = dataModel;
    },
    alertResponse(response) {
      SweetAlert.success(
        response.data.message ? response.data.message : response.errors
      ).then((result) => {
        if (result) {
          this.showHideLoading();
          this.$router.go(-1);
        }

        return result;
      });
    },
    storeUpdate() {
      const stepsToValidate = [
        'first_step',
        'second_step',
        'third_step',
        'forth_step',
        'fifth_step',
      ];

      const invalidStep = stepsToValidate.find((key) => {
        const step = this.model[key];
        if (!step || !step.plant) return false;
        return !this.hasValidData(step);
      });

      if (invalidStep) {
        SweetAlert.warning(i18n.t('sigatoka.must_have_at_least_one_register'));
        return;
      }

      this.showHideLoading(true);
      this.model.route = this.getModuleRoute;
      if (this.model.isCreate) {
        if (this.isCreate()) {
          Axios.saveMaster(this.model)
            .then((response) => {
              localStorage.removeItem('model');
              this.showHideLoading();
              this.alertResponse(response);
            })
            .catch((error) => this.showMessageErrors(error));
        } else {
          this.showMessageAccess();
          this.showHideLoading();
        }
      } else {
        if (this.isUpdate()) {
          Axios.updateMaster(this.model)
            .then((response) => {
              localStorage.removeItem('model');
              this.showHideLoading();
              this.alertResponse(response);
            })
            .catch((error) => this.showMessageErrors(error));
        } else {
          this.showMessageAccess();
          this.showHideLoading();
        }
      }
    },
    getModelLocalStorage() {
      const model = JSON.parse(localStorage.getItem('model'));
      if (!model) return false;
      this.model.farm_id = model.farm_id;
      this.model.lot_id = model.lot_id;
      this.model.date = model.date;
      this.model.age = model.age;
      this.model.hasYoungPlants = model.hasYoungPlants;
      this.model.sigatoka_config_id = model.sigatoka_config_id;

      return true;
    },
    setCaptureAge(capture) {
      this.showHideLoading(true);
      if (!capture || !capture.sigatoka_age_plants) return;
      this.model.isCreate = false;
      this.model.id = capture.id;
      const ageGroup = capture.sigatoka_age_plants.reduce((plants, plant) => {
        if (!plants[plant.age]) {
          plants[plant.age] = {
            ids: [],
            yls: [],
            yli: [],
            plant: [],
            deleted_ids: [],
            plants_count: 0,
            functional_leaf: [],
          };
        }
        plants[plant.age].plants_count++;
        plants[plant.age].ids.push(plant.id);
        plants[plant.age].yls.push(plant.yls);
        plants[plant.age].plant.push(plant.plant);
        plants[plant.age].functional_leaf.push(plant.functional_leaf);
        if (plant.age == 0) {
          plants[plant.age].yli.push(plant.yli);
        }

        return plants;
      }, {});
      const firstAge = this.model.age[0];
      const secondAge = this.model.age[1];
      const thirdAge = this.model.age[2];
      if (ageGroup[firstAge])
        this.$refs.formWizard.$refs.firstStep[0].model = {
          ...ageGroup[firstAge],
          age: this.model.age[0],
          key: 'first_step',
        };
      if (ageGroup[secondAge])
        this.$refs.formWizard.$refs.secondStep[0].model = {
          ...ageGroup[secondAge],
          key: 'second_step',
        };
      if (ageGroup[thirdAge])
        this.$refs.formWizard.$refs.thirdStep[0].model = {
          ...ageGroup[thirdAge],
          key: 'third_step',
        };
      if (this.model.age[3]) {
        const forthAge = this.model.age[3];
        if (ageGroup[forthAge])
          this.$refs.formWizard.$refs.forthStep[0].model = {
            ...ageGroup[forthAge],
            key: 'forth_step',
          };
      }
    },
    setCaptureYoung(capture) {
      if (!this.model.hasYoungPlants) return;
      if (!capture || !capture.sigatoka_young_plants) return;
      const young = {
        ids: {},
        ref: [],
        plant: [],
        leaves: [],
        plant_ids: [],
        infection: [],
        deleted_ids: [],
        plants_count: 0,
        functional_leaf: [],
      };
      capture.sigatoka_young_plants.forEach((plant) => {
        young.plants_count++;
        young.ref.push(plant.ref);
        young.plant.push(plant.plant);
        young.plant_ids.push(plant.id);
        young.functional_leaf.push(plant.functional_leaf);
        young.ids[plant.id] = plant.sigatoka_young_plant_leaves.map(
          (leaf) => leaf.id
        );
        const infections = plant.sigatoka_young_plant_leaves.map(
          (leaf) => leaf.infection || null
        );
        young.infection.push(infections);
        young.leaves = plant.sigatoka_young_plant_leaves.map(
          (leaf) => leaf.leaf || null
        );
      });
      if (young)
        this.$refs.formWizard.$refs.fifthStep[0].model = {
          ...young,
          key: 'fifth_step',
        };
    },
    async getData() {
      const data = {
        route: 'sigatoka/capture/getcapture',
        farm_id: this.model.farm_id,
        lot_id: this.model.lot_id,
        date: this.model.date,
      };
      return await Axios.postMasters(data);
    },
    deleteCapture() {
      if (this.isDelete() && !this.model.isCreate) {
        SweetAlert.delete(
          this.$t('common_words.confirm'),
          this.$t('sigatoka.confirm_capture_delete')
        ).then(async (result) => {
          if (result.value) {
            this.model.route = 'sigatoka/capture';
            await Axios.destroyMaster(this.model).then((response) => {
              localStorage.removeItem('model');
              this.alertResponse(response);
            });
          }
        });
      }
    },
  },
  async mounted() {
    this.selectedItemOnMenu('sigatoka');
    if (!this.getModelLocalStorage()) {
      return this.$router.go(-1);
    }
    if (this.isCreate() || this.isUpdate()) {
      const captureRes = await this.getData();
      await this.setCaptureAge(captureRes.data.data);
      if (this.model.hasYoungPlants)
        await this.setCaptureYoung(captureRes.data.data);
      this.showHideLoading();
    } else this.showHideLoading();
  },
  beforeDestroy() {
    this.deselectedItemOnMenu('sigatoka');
  },
};
</script>
